import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
export function getSRPPdfApi({ patentId, lang, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/srp/pdf?patentId=${patentId}&ttlLang=${lang}`,
        method: 'GET',
        transformCode: true,
    });
}
export function getFTOProjectIdsApi({ space_id, folder_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/project-list-for-search`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
